import { showToast } from '@/utils/showToast';
import { setLocale } from '@/i18n';

export const globalProperties = {
  $showToast: showToast,
  $setLocale: setLocale,
};

